// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__FXJVu","heading":"styles_heading__Skeop","image_container":"styles_image_container__zlosw","text":"styles_text__1yADx"};